import "./Politicas.css";

export default function Terminos() {
  return (
    <div className="politicas-container">
      <h1>Términos y Condiciones</h1>

      <ul>
        <li>El uso de la tienda implica aceptación de todas las políticas aquí descritas.</li>
        <li>La tienda puede modificar precios, disponibilidad y condiciones sin previo aviso.</li>
        <li>Se pueden suspender cuentas por fraude o incumplimiento de estas políticas.</li>
        <li>El cliente es responsable de la veracidad de la información suministrada.</li>
      </ul>
    </div>
  );
}
